module.exports = __webpack_public_path__ + "img/iconPerson.1d2cf945.svg";